import { API_BASE_URL } from '../client';

export const NODE_AUTO_COMPLETE_RULE_ENDPOINTS = {
  LIST: `${API_BASE_URL}/NodeAutoCompleteRule`,
  DETAIL: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}`,
  CREATE: `${API_BASE_URL}/NodeAutoCompleteRule`,
  UPDATE: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}`,
  DELETE: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}`,
  SET_ENABLED: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}/enabled`,
  TEST: `${API_BASE_URL}/NodeAutoCompleteRule/test`,
  TEST_SCRIPT: `${API_BASE_URL}/NodeAutoCompleteRule/test-script`,
  TRIGGER: `${API_BASE_URL}/NodeAutoCompleteRule/trigger`,
  TRIGGER_MQ: `${API_BASE_URL}/NodeAutoCompleteRule/trigger-mq`,
  TEST_PROJECTS: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}/test-projects`,
  RUNS: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}/runs`,
  VERSIONS: (id: number) => `${API_BASE_URL}/NodeAutoCompleteRule/${id}/versions`,
  VERSION_DETAIL: (id: number, versionId: number) =>
    `${API_BASE_URL}/NodeAutoCompleteRule/${id}/versions/${versionId}`,
};
